<template>
  <div class="breadcrumb-main">
    <div class="page-width">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{ $t('home') }}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="path1" :to="path1.path">{{path1.name}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{path2}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "breadcrumb",
  props: ['path1', 'path2']
}
</script>

<style scoped lang="less">
@import "../assets/css/navbar.less";
@import "../assets/css/public.less";
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb.vue